import React from 'react';
import { CheckCircleSolid } from '@fff-web/fff-ui-shared/Icon';
import {
  passwordContainsNumber,
  passwordContainsSpecialCharacter,
  passwordContainsUpperAndLowerCase,
} from './utilities/passwordValidation';
import styles from './scss/PasswordTooltip.module.scss';

interface PasswordToolTipProps {
  password: string
}

const GREEN = '#9dd322';

// eslint-disable-next-line max-len
const PasswordToolTip: React.FunctionComponent<PasswordToolTipProps> = (props: PasswordToolTipProps) => {
  const { password } = props;

  let stylesUpperAndLowerCase = styles.passwordTooltipCheck;
  if (passwordContainsUpperAndLowerCase(password)) {
    stylesUpperAndLowerCase = `${stylesUpperAndLowerCase} ${styles.passwordTooltipCheckValid}`;
  }

  let stylesSpecialCharacter = styles.passwordTooltipCheck;
  if (passwordContainsSpecialCharacter(password)) {
    stylesSpecialCharacter = `${stylesSpecialCharacter} ${styles.passwordTooltipCheckValid}`;
  }

  let stylesNumber = styles.passwordTooltipCheck;
  if (passwordContainsNumber(password)) {
    stylesNumber = `${stylesNumber} ${styles.passwordTooltipCheckValid}`;
  }

  let stylesLength = styles.passwordTooltipCheck;
  if (password.length > 7) {
    stylesLength = `${stylesLength} ${styles.passwordTooltipCheckValid}`;
  }

  return (
    <div className={styles.passwordTooltip}>
      <div className={styles.triangleWithShadow} />
      <p className={styles.passwordTooltipTitle}>Your password must have: </p>
      <div className={styles.passwordTooltipRow}>
        <div className={stylesLength}>
          {password.length > 7 && <CheckCircleSolid fill={GREEN} />}
        </div>
        <p className={styles.passwordTooltipTip}>8 or more characters</p>
      </div>
      <div className={styles.passwordTooltipRow}>
        <div className={stylesUpperAndLowerCase}>
          {passwordContainsUpperAndLowerCase(password)
            && <CheckCircleSolid fill={GREEN} />}
        </div>
        <p className={styles.passwordTooltipTip}>Uppercase and lowercase letters</p>
      </div>
      <div className={styles.passwordTooltipRow}>
        <div className={stylesSpecialCharacter}>
          {passwordContainsSpecialCharacter(password) && <CheckCircleSolid fill={GREEN} />}
        </div>
        <p className={styles.passwordTooltipTip}>At least 1 special character(e.g.!@#$%^)</p>
      </div>
      <div className={styles.passwordTooltipRow}>
        <div className={stylesNumber}>
          {passwordContainsNumber(password) && <CheckCircleSolid fill={GREEN} />}
        </div>
        <p className={styles.passwordTooltipTip}>At least 1 number</p>
      </div>
    </div>
  );
};

export default PasswordToolTip;
